import { createResourceQuery } from '@funtech-int/rival';
import { sportEventQuery, SportEvent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { useResources } from '@funtech-int/rival-react';

import { GraphqlClient } from '../lib/graphqlClient';

import { useGraphqlClient } from './useGraphqlClient';

interface SportEventParams {
    id: string;
}

interface SportEventQueryContext {
    params: SportEventParams;
    client: GraphqlClient;
}

const sportEventResourceQuery = createResourceQuery<SportEventQueryContext, SportEvent>({
    key(ctx) {
        return [sportEventQuery.name, ctx.params.id].join(':');
    },
    fetch(ctx) {
        return ctx.client
            .fetch({
                operation: sportEventQuery,
                variables: {
                    eventId: ctx.params.id,
                },
            })
            .then(({ data }) => {
                if (!data) {
                    throw new Error(`Empty data for sport event ${ctx.params.id}`);
                }

                return data;
            });
    },
    toJSON(data) {
        return data;
    },
    hydrate(data: any) {
        return sportEventQuery.hydrate(data) as any;
    },
});

interface UseSportEventQueryParams {
    id: string;
}

export const useSportEventQuery = ({ id }: UseSportEventQueryParams) => {
    const client = useGraphqlClient();

    const [sportEvent] = useResources(
        sportEventResourceQuery({
            client,
            params: {
                id,
            },
        })
    );

    return { sportEvent };
};
